import { EcoaCrfStatus } from "maven-lib/dist/dto/entity/ecoaCrf";
import { EcoaVisitStatus } from "maven-lib/dist/dto/entity/ecoaVisit";
import { COMMON_LANG, ECOA_CAPTURE_LANG } from "@maven-msg/lang";
import { MvnMessage } from "@maven-msg/lib/Message";

export function readableEcoaVisitStatus(status: EcoaVisitStatus, defaultVal = "Unknown"): string {
  switch (status) {
    case EcoaVisitStatus.Done:
      return MvnMessage(COMMON_LANG.COMPLETE);
    case EcoaVisitStatus.NotAvailable:
      return MvnMessage(ECOA_CAPTURE_LANG.ECOA_CAPTURE_NOT_AVAILABLE);
    case EcoaVisitStatus.NotDone:
      return MvnMessage(COMMON_LANG.INCOMPLETE);
    case EcoaVisitStatus.Ongoing:
      return MvnMessage(COMMON_LANG.IN_PROGRESS);
    default:
      return status || defaultVal;
  }
}

export function readableEcoaCrfStatus(status: EcoaCrfStatus, defaultVal = "Unknown"): string {
  switch (status) {
    case EcoaCrfStatus.Done:
      return MvnMessage(COMMON_LANG.COMPLETE);
    case EcoaCrfStatus.NotAvailable:
      return MvnMessage(ECOA_CAPTURE_LANG.ECOA_CAPTURE_NOT_AVAILABLE);
    case EcoaCrfStatus.NotDone:
      return MvnMessage(COMMON_LANG.INCOMPLETE);
    case EcoaCrfStatus.Ongoing:
      return MvnMessage(COMMON_LANG.IN_PROGRESS);
    default:
      return status || defaultVal;
  }
}
